import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-description',
  templateUrl: './setting-description.component.html',
  styleUrls: ['./setting-description.component.scss']
})
export class SettingDescriptionComponent implements OnInit {
  @Input() description: string;

  constructor() { }

  ngOnInit(): void {
  }

}
